import React, { useState, useEffect } from 'react'

import { Button, Dialog, Grid, Icon, Typography, FormHelperText } from '@material-ui/core'

import Scrollbars from "rc-scrollbars";
import CloseIcon from '@material-ui/icons/Close';
import useStyles from "./styles";
import { DraggableComponent } from '../../../../../../../../components/UiElements/UiElements';
import { TextareaField } from '../../../../../../../../components/InputField/InputField';
import { withSnackbar } from "./../../../../../../../../components/Message/Alert";
import { GetUserInfo } from '../../../../../../../../Services/GetUserInfo';
import DialogLoader from './../../../../../../../../components/Loader/DialogLoader';


import { getFormatedDate } from '../../../../../../../../components/Common/Extensions';

function StatusSummary({ dialogOpenClose, handleClose, trackNumberDetails, ...props }) {
    const classes = useStyles();
    const { showMessage } = props;

    var user = sessionStorage.getItem('user_info');
    var userdata = JSON.parse(user).user;
    const [errorMessages, setErrorMessages] = useState({ errorComment: false, })
    const [state, setState] = useState({});
    const [loginUser] = useState(JSON.parse(GetUserInfo()).user);
    const [isLoading, setIsLoading] = useState(false);
    const handleChange = (e) => {
        const { name, value } = e.target;
        setState(prevState => ({
            ...prevState,
            [name]: value
        }));
    }
    const [shipmentActivityDetails, setShipmentActivityDetails] = useState([]);
    const isEmptyOrSpace = (_value) => {
        const isEmptyOrSpaces = /^\s*$/.test(_value);
        return isEmptyOrSpaces;
    }
    const saveManualComments = () => {
        let errorList = [];
        if (!state.comment || isEmptyOrSpace(state.comment)) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorComment: true
            }));
            errorList.push(true);
        } else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorComment: false
            }));
        }
        if (errorList.length < 1) {
            setIsLoading(true);
            var comment = state.comment;
            setShipmentActivityDetails(prevDetails => [
                [{ type: 'Manual', activityDetails: comment, createDate: new Date() }],
                ...prevDetails,

            ]);
            // console.log(shipmentActivityDetails, 'Comments Details')
            setState(prevState => ({
                ...prevState,
                comment: ''
            }));
            setIsLoading(false);
        }
    }
    const FirstLetter = ({ word }) => {
        const firstLetter = word.charAt(0).toUpperCase();
        return <span>{firstLetter}</span>;
    };
    useEffect(() => {
    }, []);

    return (
        <>
            <Dialog
                classes={{ paper: classes.dialogPaper }}
                disableEscapeKeyDown
                open={dialogOpenClose}
                PaperComponent={DraggableComponent}
                maxWidth="md"
                {...props} >
                <div className={classes.activeDialogContent}>
                    <div className={classes.box}>
                        <div className={classes.header} id="draggable-dialog-title">
                            <Typography className={classes.title}>Issue Report</Typography>
                            <Icon className={classes.closeIcon} onClick={handleClose} color="primary"><CloseIcon /></Icon>
                        </div>
                        {isLoading ? <DialogLoader></DialogLoader> : ''}
                        <Scrollbars autoHeight autoHeightMax={540}>
                            <div className={classes.content}>
                                <Grid row xl={12} md={12} sm={12} lg={12} className={classes.paddingLeftRight}>

                                    <div className={classes.ListContain}>

                                        <div className={classes.addfield}>

                                        </div>

                                        <div className={classes.recentActivityList}>

                                            <Grid row container lg={12} alignItems="normal">
                                                <Grid item row lg={2} className="textRight">
                                                    <div className={classes.userDetail}>
                                                        <FirstLetter word={userdata.firstName} />     <FirstLetter word={userdata.lastName} />
                                                    </div>

                                                </Grid>
                                                <Grid item row lg={9} className={classes.borderContent}>
                                                    <TextareaField
                                                        name="comment"
                                                        rows={3}
                                                        placeholder="Leave a Comment"
                                                        MaxLength="2000"
                                                        onChange={handleChange}
                                                        value={state.comment}
                                                    ></TextareaField>
                                                    <div className={classes.floatRight}>
                                                        <Button className={classes.changeBtn} onClick={saveManualComments}>Submit</Button>
                                                    </div>
                                                    {errorMessages.errorComment && (!state.comment || isEmptyOrSpace(state.comment)) ? (<FormHelperText style={{ color: "red" }} >
                                                        Please enter comment
                                                    </FormHelperText>) : ('')}
                                                </Grid>

                                            </Grid>
                                        </div>


                                        {shipmentActivityDetails.map((item, i) => {
                                            return (
                                                <>
                                                    {item.map((activityItem, i) => {
                                                        return (
                                                            <>
                                                                <div className={classes.recentActivityList}>
                                                                    <Grid row container lg={12}>
                                                                        <Grid item row lg={2} className="textRight"> <div className={classes.userDetails}></div> </Grid>
                                                                        <Grid item row lg={9} className={classes.borderContent}>
                                                                            <div className={classes.flexRow}>
                                                                                <div style={{
                                                                                    fontSize: '16px',
                                                                                    whiteSpace: 'break-spaces',
                                                                                    width: '80%',
                                                                                    textAlign: 'justify'
                                                                                }}>
                                                                                    {activityItem.activityDetails}
                                                                                    <h2>{getFormatedDate(item[0].createDate, 'MMM DD,YYYY')}</h2>
                                                                                </div>
                                                                                <span className={classes.contentTime}>
                                                                                    {getFormatedDate(item[0].createDate, 'hh:mm A')}
                                                                                </span>
                                                                            </div>
                                                                        </Grid>
                                                                    </Grid>
                                                                </div>
                                                            </>
                                                        )
                                                    })}
                                                </>
                                            )
                                        })}
                                    </div>
                                </Grid>
                            </div>
                        </Scrollbars>
                        <div className={classes.footer}>
                            <div className={classes.footerRight}>
                                <Button className={classes.backBtn} onClick={handleClose}>Cancel</Button>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog >
        </>
    )
}

export default withSnackbar(StatusSummary);